import { bindActionCreators } from "redux"
import { useDispatch } from "react-redux"
import * as FilterActionCreators from "../redux/actionCreators/filter"
import {
  AudiencesActionCreators,
  DisplaySettingsActionCreators,
  SponsoredProductActionCreators as SponsoredProductActionCreatorsSKC,
} from "../modules/sponsoredProductsSKCAntd"
import { SponsoredProductActionCreators } from "../modules/sponsoredProducts"
import { ManyTargetCampaignsActionCreators } from "../modules/manyTargetsCampaignsHistory"
import { ProjectActionCreators } from "../modules/projects"
import { ProjectDataActionCreators } from "../modules/projectDataAsin"
import { ProjectDataSettingsActionCreators } from "../modules/ProjectDataSettings"
import { ProjectDataKeywordsActionCreators } from "../modules/projectDataKewords"
import { ProjectDataRanksActionCreators } from "../modules/projectDataRanks"
import { ProjectDataSQPActionCreators } from "../modules/ProjectDataSQP"
import CampaignsActionCreators from "../redux/actionCreators/campaigns"
import ProjectListActionCreators from "../redux/actionCreators/projectList"
import { PlacementsActionCreators } from "../modules/sponsoredProductsSKCAntd"
import { CustomerActionCreator } from "../modules/customers"
import {
  sbPlacementsActionCreators,
  sponsoredBrandsActionCreators,
} from "../modules/sponsoredBrands"

export const useActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators(
    {
      ...FilterActionCreators,
      ...SponsoredProductActionCreatorsSKC,
      ...DisplaySettingsActionCreators,
      ...SponsoredProductActionCreators,
      ...ManyTargetCampaignsActionCreators,
      ...ProjectActionCreators,
      ...ProjectDataActionCreators,
      ...ProjectDataSettingsActionCreators,
      ...ProjectDataKeywordsActionCreators,
      ...ProjectDataRanksActionCreators,
      ...ProjectDataSQPActionCreators,
      ...CampaignsActionCreators,
      ...ProjectListActionCreators,
      ...AudiencesActionCreators,
      ...PlacementsActionCreators,
      ...CustomerActionCreator,
      ...sponsoredBrandsActionCreators,
      ...sbPlacementsActionCreators,
    },
    dispatch
  )
}
